import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import { SocialLink } from '../types';

interface SocialLinksProps {
  links: SocialLink[];
}

const SocialLinks = ({ links }: SocialLinksProps) => {
  return (
    <motion.div
      initial={{ y: 20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, delay: 0.7 }}
      className="flex items-center justify-center gap-4 mb-16"
    >
      {links.map((link) => (
        <a
          key={link.id}
          href={link.url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={link.ariaLabel}
          className="w-12 h-12 rounded-full bg-surface hover:bg-accent transition-all duration-300 flex items-center justify-center group shadow-brand hover:shadow-brand-lg hover:scale-110"
        >
          <Icon
            name={link.iconName}
            size={20}
            className="text-secondary group-hover:text-white transition-colors duration-300"
          />
        </a>
      ))}
    </motion.div>
  );
};

export default SocialLinks;